<div class="wrap" *ngIf="!loadingStatusAnswered$() else loading">
    <que-status-recipients-item class="item-flex" [status]="eReplyStatus.NotStarted"></que-status-recipients-item>
    <que-status-recipients-item class="item-flex" [status]="eReplyStatus.InProgress"></que-status-recipients-item>
    <que-status-recipients-item class="item-flex" [status]="eReplyStatus.Finished"></que-status-recipients-item>
</div>

<ng-template #loading>
    <div class="wrap">
        <div class="content-item load"></div>
        <div class="content-item load"></div>
        <div class="content-item load"></div>
    </div>
</ng-template>